import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '../../lib/utils';
import { Dialog as HeadlessDialog, Transition } from '@headlessui/react';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

type DialogProps = React.ComponentProps<typeof HeadlessDialog> & {
    hideCloseButton?: boolean;
};

const DialogRoot = ({ className, open, onClose, hideCloseButton, children, ...props }: DialogProps) => {
    return (
        <Transition show={open} as={React.Fragment}>
            <HeadlessDialog onClose={onClose} className="relative z-50" {...props}>
                <Transition.Child
                    as={React.Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/30" />
                </Transition.Child>

                <div className="fixed inset-0 flex w-screen items-center justify-center p-4 ">
                    <Transition.Child
                        as={React.Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <HeadlessDialog.Panel className="relative flex flex-col gap-3 w-full max-w-md shadow-xl p-6 bg-white">
                            <>
                                {!hideCloseButton && (
                                    <button className="absolute top-6 right-6">
                                        <FontAwesomeIcon
                                            icon={faClose}
                                            className="text-2xl text-primary"
                                            onClick={() => {
                                                onClose(false);
                                            }}
                                        />
                                    </button>
                                )}
                                {children}
                            </>
                        </HeadlessDialog.Panel>
                    </Transition.Child>
                </div>
            </HeadlessDialog>
        </Transition>
    );
};

const DialogTitle = ({ className, children }: { className?: string; children: React.ReactNode }) => {
    return <h3 className={cn('text-primary text-xl', className)}>{children}</h3>;
};

export const Dialog = Object.assign(DialogRoot, {
    Title: DialogTitle,
});
